import { Component, HostListener } from '@angular/core';
import {InformacionService} from "../../services/informacion.service";
import { TranslateService } from 'ng2-translate';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})

export class HeaderComponent {
  menuAbierto:boolean = false;
  menuIdiomas:boolean = false;
  menuHome:boolean = true;
  currentLang:any = '';
  lastScroll:any = 0;

  seccionesArray:any = ['biografia', 'proceso', 'obras', 'organeria', 'contacto'];

  @HostListener('window:scroll', ['$event'])
  doSomething(event) {

      var altoMax = window.innerHeight - 150;
      var posScroll = window.pageYOffset;
      var baseScroll = posScroll + window.innerHeight;


      //EVAL DIRECCION
      if(posScroll > this.lastScroll) { //BAJA
      }
      else { //SUBE

      }


      for (let key of this.seccionesArray) {

        var keyElement = document.getElementById(key);
        var keyPos = keyElement.offsetTop;
        var keyAlto = keyElement.offsetTop + keyElement.offsetHeight;

        if((keyPos > posScroll && keyPos < baseScroll) || (keyAlto > posScroll && keyAlto < baseScroll)) {
          //keyElement.classList.add("show");
        }
        else {
            //keyElement.classList.remove("show");
        }
      }


      this.lastScroll = posScroll;



      if(posScroll >= altoMax) {
        this.menuHome = false;
      }
      else {
        this.menuHome = true;
      }
    }


  constructor( public _is:InformacionService, private translate:TranslateService ){
  }

  switchMenu() {
    this.menuAbierto = !this.menuAbierto;
  }

  switchMenuIdiomas() {
    this.menuIdiomas = !this.menuIdiomas;
  }


  getLang() {

    if(this.currentLang) {
      return this.currentLang;
    }
    else{
      return this.translate.getBrowserLang();
    }
  }

  scroll(el) {
    el.scrollIntoView();
    //window.scrollTo(0, el.offsetTop, 500);
  }

}



// WEBPACK FOOTER //
// /Users/administrador/Trabajos/pascal3/src/app/components/header/header.component.ts